/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add as many as you like, one per line. Two or more are needed to spin; very long lists just make thinner segments.`)
};

const es_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade tantas como quieras, una por línea. Se necesitan dos o más para girar; las listas muy largas solo hacen los segmentos más finos.`)
};

const de_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge so viele hinzu, wie du möchtest, eine pro Zeile. Für das Drehen sind mindestens zwei nötig; sehr lange Listen ergeben einfach dünnere Segmente.`)
};

const nl_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg er zoveel toe als je wilt, één per regel. Er zijn er minstens twee nodig om te draaien; heel lange lijsten geven gewoon dunnere segmenten.`)
};

const fr_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez-en autant que vous voulez, une par ligne. Il en faut au moins deux pour faire tourner la roue ; les listes très longues créent simplement des segments plus fins.`)
};

const it_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungine quante vuoi, una per riga. Ne servono almeno due per girare; elenchi molto lunghi creano semplicemente spicchi più sottili.`)
};

const pt_br2_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione quantas quiser, uma por linha. É preciso pelo menos duas para girar; listas muito longas só deixam os segmentos mais finos.`)
};

const pt_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione quantas quiser, uma por linha. São precisas pelo menos duas para girar; listas muito longas resultam apenas em segmentos mais finos.`)
};

const ja_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行に1つずつ、好きなだけ追加できます。回すには2つ以上必要で、非常に多くの選択肢を入れるとセグメントが細くなるだけです。`)
};

const zh_dw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以添加任意数量，每行一个。转动至少需要两个选项；选项过多只会使扇形区域变得更窄。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_faq_a2", locale)
	if (locale === "en") return en_dw_faq_a2(inputs)
	if (locale === "es") return es_dw_faq_a2(inputs)
	if (locale === "de") return de_dw_faq_a2(inputs)
	if (locale === "nl") return nl_dw_faq_a2(inputs)
	if (locale === "fr") return fr_dw_faq_a2(inputs)
	if (locale === "it") return it_dw_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_dw_faq_a2(inputs)
	if (locale === "pt") return pt_dw_faq_a2(inputs)
	if (locale === "ja") return ja_dw_faq_a2(inputs)
	return zh_dw_faq_a2(inputs)
};